import React, { useState } from 'react';
import './DiscoverArtistsSection.css';

const DiscoverArtistsSection = () => {
  const [selectedGenre, setSelectedGenre] = useState('fusion');
  const [selectedLocation, setSelectedLocation] = useState('All');
  const [selectedVenue, setSelectedVenue] = useState(null);
  // const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [sortBy, setSortBy] = useState('popular');
  const [startDate, setStartDate] = useState('2025.9.22');
  const [endDate, setEndDate] = useState('2025.10.22');

  const genres = ['All', 'Rock/Pop', 'Electronics', 'Hiphop', 'fusion'];
  const locations = ['All', 'Seoul', 'Gyunggi', 'Incheon', 'Busan'];


  // Dynamic venues based on location
  // const getVenuesByLocation = (location) => {
  //   const venueMap = {
  //     'Seoul': ['BBCB', 'teller', 'Cakeshop', 'UNDERCITY', 'vurt.', 'Faust', 'Club Octagon', 'Club Syndrome'],
  //     'Busan': ['Club Syndrome', 'Club Octagon', 'BBCB Busan', 'teller Busan'],
  //     'Incheon': ['Club Syndrome Incheon', 'BBCB Incheon', 'teller Incheon'],
  //     'Daegu': ['Club Syndrome Daegu', 'BBCB Daegu', 'teller Daegu'],
  //     'Daejeon': ['Club Syndrome Daejeon', 'BBCB Daejeon', 'teller Daejeon'],
  //     'Gwangju': ['Club Syndrome Gwangju', 'BBCB Gwangju', 'teller Gwangju'],
  //     'Ulsan': ['Club Syndrome Ulsan', 'BBCB Ulsan', 'teller Ulsan'],
  //     'Jeju': ['Club Syndrome Jeju', 'BBCB Jeju', 'teller Jeju']
  //   };
  //   return venueMap[location] || [];
  // };

  // Featured performances data
  const featuredPerformances = [
    {
      id: 1,
      artist: "Fiona",
      title: "We are the universe",
      date: "9.22 Mon @7pm",
      location: "BBCB, Itaewon",
      venue: "BBCB",
      city: "Seoul",
      likes: 57,
      rating: "10/10",
      genre: "fusion",
      image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&h=200&fit=crop"
    },
    {
      id: 2,
      artist: "Fiona",
      title: "We are the universe",
      date: "9.22 Mon @7pm",
      location: "BBCB, Itaewon",
      venue: "BBCB",
      city: "Seoul",
      likes: 57,
      rating: "10/10",
      genre: "fusion",
      image: "https://images.unsplash.com/photo-1516280440614-37939bbacd81?w=300&h=200&fit=crop"
    },
    {
      id: 3,
      artist: "Fiona",
      title: "We are the universe",
      date: "9.22 Mon @7pm",
      location: "BBCB, Itaewon",
      venue: "BBCB",
      city: "Seoul",
      likes: 57,
      rating: "10/10",
      genre: "fusion",
      image: "https://images.unsplash.com/photo-1598653222000-6b7b7a552625?w=300&h=200&fit=crop"
    },
    {
      id: 4,
      artist: "Fiona",
      title: "We are the universe",
      date: "9.22 Mon @7pm",
      location: "BBCB, Itaewon",
      venue: "BBCB",
      city: "Seoul",
      likes: 57,
      rating: "10/10",
      genre: "fusion",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=200&fit=crop"
    },
    {
      id: 5,
      artist: "Fiona",
      title: "We are the universe",
      date: "9.22 Mon @7pm",
      location: "BBCB, Itaewon",
      venue: "BBCB",
      city: "Seoul",
      likes: 57,
      rating: "10/10",
      genre: "fusion",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=200&fit=crop"
    },
    {
      id: 6,
      artist: "Fiona",
      title: "We are the universe",
      date: "9.22 Mon @7pm",
      location: "BBCB, Itaewon",
      venue: "BBCB",
      city: "Seoul",
      likes: 57,
      rating: "10/10",
      genre: "fusion",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300&h=200&fit=crop"
    }
  ];

  // Filter performances based on selected filters
  const getFilteredPerformances = () => {
    let filtered = featuredPerformances.filter(performance => {
      const genreMatch = selectedGenre === 'All' || performance.genre === selectedGenre;
      const locationMatch = selectedLocation === 'All' || performance.city === selectedLocation;
      const venueMatch = !selectedVenue || performance.venue === selectedVenue;
      
      return genreMatch && locationMatch && venueMatch;
    });

    // Sort by selected criteria
    if (sortBy === 'popular') {
      filtered.sort((a, b) => b.likes - a.likes);
    } else if (sortBy === 'date') {
      filtered.sort((a, b) => new Date(a.date) - new Date(b.date));
    }

    return filtered;
  };

  const handleFilterClick = (filterType, value) => {
    switch (filterType) {
      case 'genre':
        setSelectedGenre(value);
        break;
      case 'location':
        setSelectedLocation(value);
        setSelectedVenue(null); // Reset venue when location changes
        break;
      case 'venue':
        setSelectedVenue(selectedVenue === value ? null : value);
        break;
      default:
        break;
    }
  };

  const handleSearch = () => {
    // Search functionality can be implemented here
    console.log('Searching with filters:', { selectedGenre, selectedLocation, startDate, endDate });
  };

  const filteredPerformances = getFilteredPerformances();
  // const availableVenues = selectedLocation ? getVenuesByLocation(selectedLocation) : [];

  return (
    <section className="discover-artists" id="artists">
      <div className="container">
        <div className="section-header">
          <h2>Discover The Stage</h2>
        </div>
        
        {/* Search Bar Section */}
        <div className="search-section">
          <div className="search-bar-container">
            <div className="filter-row">
              <div className="filter-group">
                <div className="filter-tags">
                  {genres.map((genre) => (
                    <span
                      key={genre}
                      className={`tag ${selectedGenre === genre ? 'active' : ''}`}
                      onClick={() => handleFilterClick('genre', genre)}
                    >
                      {genre}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="filter-row">
              <div className="filter-group">
                <div className="filter-tags">
                  {locations.map((location) => (
                    <span
                      key={location}
                      className={`tag ${selectedLocation === location ? 'active' : ''}`}
                      onClick={() => handleFilterClick('location', location)}
                    >
                      {location}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="date-range-row">
              <div className="date-input-group">
                <i className="fas fa-calendar"></i>
                <input 
                  type="text" 
                  value={startDate} 
                  onChange={(e) => setStartDate(e.target.value)}
                  className="date-input"
                />
              </div>
              <div className="date-input-group">
                <i className="fas fa-calendar"></i>
                <input 
                  type="text" 
                  value={endDate} 
                  onChange={(e) => setEndDate(e.target.value)}
                  className="date-input"
                />
              </div>
              <button className="search-btn" onClick={handleSearch}>
                SEARCH
              </button>
            </div>
          </div>
        </div>
        
        {/* Search Results Section */}
        <div className="search-results-section">
          <div className="results-header">
            <div className="active-filters">
              <span className="filter-display">
                {selectedGenre} X {selectedLocation} X
              </span>
            </div>
            <div className="sort-options">
              <button 
                className={`sort-btn ${sortBy === 'popular' ? 'active' : ''}`}
                onClick={() => setSortBy('popular')}
              >
                Popular
              </button>
              <button 
                className={`sort-btn ${sortBy === 'date' ? 'active' : ''}`}
                onClick={() => setSortBy('date')}
              >
                Date
              </button>
            </div>
          </div>
          
          <div className="events-grid">
            {filteredPerformances.map((event) => (
              <div key={event.id} className="event-card">
                <div className="event-image">
                  <img src={event.image} alt={event.title} />
                  <div className="event-icons">
                    <div className="event-icon purple-icon"></div>
                    <div className="event-icon heart-icon">
                      <i className="far fa-heart"></i>
                    </div>
                  </div>
                </div>
                <div className="event-info">
                  <h3 className="artist-name">{event.artist}</h3>
                  <h4 className="event-title">{event.title}</h4>
                  <div className="event-details">
                    <div className="event-detail">
                      <i className="fas fa-clock"></i>
                      <span>{event.date}</span>
                    </div>
                    <div className="event-detail">
                      <i className="fas fa-map-marker-alt"></i>
                      <span>{event.location}</span>
                    </div>
                    <div className="event-detail">
                      <i className="fas fa-heart"></i>
                      <span>{event.likes}</span>
                    </div>
                    <div className="event-detail">
                      <i className="fas fa-star"></i>
                      <span>{event.rating}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscoverArtistsSection; 